import { render, staticRenderFns } from "./BookingPolicyForm.vue?vue&type=template&id=65fb9706&scoped=true&"
import script from "./BookingPolicyForm.vue?vue&type=script&lang=js&"
export * from "./BookingPolicyForm.vue?vue&type=script&lang=js&"
import style0 from "./BookingPolicyForm.vue?vue&type=style&index=0&id=65fb9706&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fb9706",
  null
  
)

export default component.exports